import { createFileRoute, redirect } from '@tanstack/react-router';

import { postAuthIntent } from '../auth/postAuth';
import { allowedReturnOrigin } from '../auth/returnOrigin';
import { AccountReadyPage } from '../pages/AccountReadyPage';

/**
 * The sign-in redirect's target. MSAL has already finished the redirect at boot (main.tsx), so the
 * session either exists or it does not, and the redirect's intent says where to go: back to a page
 * of this site, or — after sign-up — on to the allow-listed app the person came from.
 */
export const Route = createFileRoute('/auth/callback')({
  beforeLoad: ({ context }) => {
    const intent = postAuthIntent();
    if (context.auth.status !== 'authenticated' || intent === null) {
      throw redirect({ to: '/', replace: true });
    }
    if (intent.kind === 'path') throw redirect({ href: intent.path, replace: true });
    const continueTo = allowedReturnOrigin(intent.returnOrigin, context.returnOrigins);
    if (continueTo === null) throw redirect({ to: '/', replace: true });
    return { continueTo };
  },
  component: AccountReadyRoute,
});

function AccountReadyRoute() {
  const { continueTo } = Route.useRouteContext();
  return <AccountReadyPage origin={continueTo} />;
}
